(window as any).__Zone_enable_cross_context_check = true;